import { useState } from 'react';
import variables from 'styles/variables.module.scss';
/**
 * # getButtonColorSchemaStyle
 * Function that receives the colorSchema and creates the color definition of the table buttons
 * @function useGetButtonColorSchemaStyle
 * @param {string} colorSchema - Color value related to the insurance company.
 * @param {string} containerBackgroundColor - Fill color of the button parent container.
 * @param {boolean} reverse - Invert the color distribution of the button on (base and hover state).
 * @param {string} borderColor - Color value of the
 * @return {object} Button props with all the color definition, base and hover state.
 */
export default function useGetButtonColorSchemaStyle (
    colorSchema = variables.grayLighterColor,
    containerBackgroundColor = variables.whiteColor,
    reverse,
    borderColor = variables.textColor
) {
    const [isHovering, setIsHovering] = useState(false);

    const onMouseEnter = () => {
        setIsHovering(true);
    };

    const onMouseLeave = () => {
        setIsHovering(false);
    };
    const baseStyle = isHovering ?
        {
            color: containerBackgroundColor,
            backgroundColor: colorSchema
        } :
        {
            color: borderColor,
            backgroundColor: containerBackgroundColor
        };
    const reverseStyle = isHovering ?
        {
            color: colorSchema,
            backgroundColor: containerBackgroundColor
        } :
        {
            color: containerBackgroundColor,
            backgroundColor: colorSchema
        };
    return {
        onMouseEnter,
        onMouseLeave,
        style: reverse ? reverseStyle : baseStyle
    };
}
